module.exports = __webpack_public_path__ + "static/media/1.3005a8d9.PNG";